import type { LucideIcon } from 'lucide-react';

/** Grupos do menu na ordem do PRD §21 (Integrações fora do escopo — DEC-001), com o Diagnóstico (T-160b; DEC-061). */
export const NAV_GROUPS = [
  { id: 'overview', label: 'Visão Geral' },
  { id: 'diagnosis', label: 'Diagnóstico' },
  { id: 'strategy', label: 'Estratégia' },
  { id: 'indicators', label: 'Indicadores' },
  { id: 'planning', label: 'Planejamento' },
  { id: 'execution', label: 'Execução' },
  { id: 'management', label: 'Gestão' },
  { id: 'reports', label: 'Relatórios' },
  { id: 'settings', label: 'Configurações' },
] as const;

export type NavGroupId = (typeof NAV_GROUPS)[number]['id'];

export type NavItem = {
  /** Caminho da rota (é também a chave do item). */
  to: string;
  label: string;
  icon: LucideIcon;
  group: NavGroupId;
  /** Aparece na barra inferior do celular (máximo 4 itens). */
  mobilePrimary?: boolean;
  /** Contador ao lado do item (ex.: alertas abertos) e o texto dele para leitores de tela. */
  badge?: { count: number; label: string };
};

export type NavSection = { id: NavGroupId; label: string; items: NavItem[] };

/** Agrupa os itens disponíveis na ordem do PRD, omitindo grupos sem nenhuma tela. */
export function buildNavSections(items: NavItem[]): NavSection[] {
  return NAV_GROUPS.map((g) => ({
    id: g.id,
    label: g.label,
    items: items.filter((i) => i.group === g.id),
  })).filter((s) => s.items.length > 0);
}

export const MAX_MOBILE_PRIMARY = 4;

/** Itens da barra inferior do celular; só existe barra com pelo menos 2 destinos. */
export function mobilePrimaryItems(items: NavItem[]): NavItem[] {
  const primary = items.filter((i) => i.mobilePrimary).slice(0, MAX_MOBILE_PRIMARY);
  return primary.length >= 2 ? primary : [];
}
